import { render, staticRenderFns } from "./resourceCenter.vue?vue&type=template&id=f655dd44&"
import script from "./resourceCenter.vue?vue&type=script&lang=js&"
export * from "./resourceCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports